import React from 'react';
import { THEME } from '../../utils/theme';
import Spinner from '../ui/Spinner';

const SyncProgress = ({ syncStatus, onRetry }) => {
  if (!syncStatus) return null;
  const { status, games_found, games_added, games_updated, error_message, failed_appids_count } = syncStatus;
  const isRunning = status === 'running' || status === 'queued';
  const isFailed = status === 'failed';
  const progress = games_found > 0 ? Math.round(((games_added + games_updated) / games_found) * 100) : 0;
  if (!isRunning && !isFailed) return null;

  return (
    <div style={{ background: THEME.bgCard, border: `1px solid ${THEME.border}`, borderRadius: '14px', padding: '18px 20px', margin: '16px 24px', animation: 'slideDown 0.3s ease' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: isRunning ? '12px' : 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {isRunning && <Spinner size={18} />}
          <span style={{ color: THEME.text, fontWeight: '600', fontSize: '14px' }}>{isRunning ? 'Syncing Steam Libraries...' : 'Sync Failed'}</span>
        </div>
        {isFailed && <button onClick={onRetry} style={{ background: THEME.omega, color: '#000', border: 'none', borderRadius: '8px', padding: '8px 16px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>Retry</button>}
      </div>
      {isRunning && (
        <>
          <div style={{ background: THEME.bg, borderRadius: '6px', height: '6px', overflow: 'hidden', marginBottom: '10px' }}>
            <div style={{ background: `linear-gradient(90deg, ${THEME.omega}, ${THEME.supe})`, height: '100%', width: `${progress}%`, transition: 'width 0.3s ease', borderRadius: '6px' }} />
          </div>
          <div style={{ color: THEME.textMuted, fontSize: '12px' }}>
            Found {games_found} games · Added {games_added} · Updated {games_updated}
            {failed_appids_count > 0 && <span style={{ color: THEME.warning }}> · {failed_appids_count} failed</span>}
          </div>
        </>
      )}
      {isFailed && error_message && <div style={{ color: THEME.danger, fontSize: '13px', marginTop: '10px' }}>{error_message}</div>}
    </div>
  );
};

export default SyncProgress;
